var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyingAWatch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5411",
  transform: "translate(11728 3847)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#f1f1f1",
  "data-name": "Ellipse 737",
  transform: "translate(-11728 -3847)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5462"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-11700.137-3835.88h15.067l.989 5.021h-16.842Z",
  "data-name": "Path 5088"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-11684.871-3786.119h-15.064l-.989-5.021h16.842Z",
  "data-name": "Path 5089"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#12223e",
  "data-name": "Group 5484"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#12223e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M-11675.775-3812.133v2.329a.634.634 0 0 1-.635.636h-.831a15.6 15.6 0 0 0 .049-3.6h.781a.636.636 0 0 1 .636.635",
  "data-name": "Path 5050"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12223e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m-11676.65-3817.014.5 1.5c.076.224-.132.5-.463.612l-.787.266a7.2 7.2 0 0 0-.734-2.328l.739-.251c.334-.115.669-.023.745.201",
  "data-name": "Path 5051"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12223e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m-11676.293-3806.392-.361 1.537c-.054.231-.377.355-.718.274l-.8-.191a7.3 7.3 0 0 0 .439-1.3 7 7 0 0 0 .169-1.066l.76.179c.332.083.565.336.511.567",
  "data-name": "Path 5052"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M-11682.051-3822.332a15.3 15.3 0 0 0-2.943-2.024c-.181-.094-.362-.189-.542-.274a16.43 16.43 0 0 0-14.19 0c-.181.085-.362.17-.542.274a15 15 0 0 0-2.942 2.024l2.772-9.322a1.16 1.16 0 0 1 1.095-.955h13.427a1.18 1.18 0 0 1 1.1.955Z",
  "data-name": "Path 5085"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M-11693.353-3807.189c3.223 2.252 6.538-2.828 4.23-4.472-2.606-1.856-2.344 1.4.1-.32 3.223-2.248.573-5.542-2.777-3.237-14.639 10.079.177 13.937-.136-2.476"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11677.04-3810.884a15.62 15.62 0 0 1-7.954 13.6c-.181.1-.361.2-.542.291a15.64 15.64 0 0 1-14.19 0c-.181-.09-.362-.191-.542-.291a15.592 15.592 0 0 1-2.942-25.046 15 15 0 0 1 2.942-2.149c.181-.11.361-.2.542-.291a15.58 15.58 0 0 1 14.19 0c.181.09.361.191.542.291a15.3 15.3 0 0 1 2.943 2.149 15.54 15.54 0 0 1 4.931 9.862 14 14 0 0 1 .08 1.584Z",
  "data-name": "Path 5086"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m-11682.152-3799.285-2.782 9.345a1.16 1.16 0 0 1-1.1.952h-13.421a1.16 1.16 0 0 1-1.1-.952l-2.782-9.345h.3a15.6 15.6 0 0 0 2.772 1.875c.181.094.361.188.542.273a16.56 16.56 0 0 0 14.19 0c.181-.085.362-.179.542-.273a15.4 15.4 0 0 0 2.782-1.875Z",
  "data-name": "Path 5087"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11692.906-3823.124v1.786",
  "data-name": "Line 1824"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11692.906-3800.625v1.786",
  "data-name": "Line 1825"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11680.764-3810.905h-1.786",
  "data-name": "Line 1826"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11703.263-3810.905h-1.786",
  "data-name": "Line 1827"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11684.095-3819.491-1.263 1.263",
  "data-name": "Line 1828"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11700.005-3803.582-1.263 1.263",
  "data-name": "Line 1829"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11684.323-3802.319-1.263-1.263",
  "data-name": "Line 1830"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11700.233-3818.228-1.263-1.263",
  "data-name": "Line 1831"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11680.215-3810.885a12.44 12.44 0 0 1-6.334 10.829c-.144.08-.288.16-.432.232a12.45 12.45 0 0 1-11.3 0c-.144-.072-.288-.152-.432-.232a12.417 12.417 0 0 1-2.343-19.946 12 12 0 0 1 2.343-1.712c.144-.088.288-.16.432-.232a12.4 12.4 0 0 1 11.3 0q.216.11.432.232a12.2 12.2 0 0 1 2.343 1.712 12.38 12.38 0 0 1 3.927 7.854 11 11 0 0 1 .064 1.263Z",
  "data-name": "Path 5094"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11692.906-3822.231v1.654",
  "data-name": "Line 1840"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11692.906-3801.386v1.654",
  "data-name": "Line 1841"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11681.657-3810.911h-1.654",
  "data-name": "Line 1842"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "M-11702.502-3810.911h-1.654",
  "data-name": "Line 1843"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11684.743-3818.865-1.17 1.17",
  "data-name": "Line 1844"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11699.483-3804.125-1.17 1.17",
  "data-name": "Line 1845"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11684.954-3802.955-1.17-1.17",
  "data-name": "Line 1846"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1.5,
  d: "m-11699.694-3817.695-1.17-1.17",
  "data-name": "Line 1847"
}))))));
export { SvgBuyingAWatch as ReactComponent };
export default "/_next/static/images/buyingAWatch.svg";